---
title: 'Creative Workshop: Night at the Museum'
date: '2018-05-26'
excerpt: >-
  Wie ein kreativer Workshop im ZKM Karlsruhe unser Team zu neuen Lösungen
  geführt hat – mit Museumsatmosphäre, Gruppenarbeit und Impulsen zur
  Ideenfindung.
metaTitle: 'Creative Workshop: Night at the Museum - EmpowerMensch'
metaDescription: >-
  Erfahren Sie, wie unser Team im ZKM Karlsruhe kreative Methoden und wechselnde
  Perspektiven genutzt hat, um innovative Problemlösungen zu entwickeln.
language: de
slug: creative-workshop-night-at-the-museum
author: Kevin Rassner
metaImageAlt: 'Creative Workshop: Night at the Museum'
metaImageTitle: 'Creative Workshop: Night at the Museum'
---
![Creative Workshop: Night at the Museum](/assets/blog/creative-workshop-night-at-the-museum/creative-workshop-night-at-the-museum.png "Creative Workshop: Night at the Museum")

My team and I faced a special challenge at the beginning of the year that required creative solutions. Since the time in the team meetings is often sparse and the participants cannot let go completely due to the pressure of work, I decided to discard a few thought patterns and thus help the team to leave theirs.

As I pointed out in [a previous article](/blog/why-alexa-couldnt-help-me-find-a-more-creative-title), stimulation, observation and breaking out of old thought patterns are the fuel that could be helpful in creatively solving problems.

The following points were important when organizing a creative workshop:

- A geographical change to leave the usual environment (distraction by work)
- An environment that inspires us
- Freedom, movement and dynamics should be possible

After researching, I came across the exhibition [Open Codes](https://open-codes.zkm.de/de) at the Zentrum für Kunst und Medien Karlsruhe. It presents the meaning of software in our lives, offering a perfect mixture of thematically relevant information and inspiration. I was impressed by the open design and integration of public workplaces into the exhibition, including seating groups and tables, [which can be rented](https://open-codes.zkm.de/de/raumbuchung) for meetings, workshops or diversified work.

In February, the time had come. 14 engineers met at the ZKM, equipped only with a presentation case and many questions.

As per current brainstorming methods, we sought as much input as possible - fortunately being in a museum, there was no lack. Some wanted to study the exhibition, others preferred developing ideas directly.

Afterwards, we worked in groups, breaking down the most important team problems and formulating approaches to solutions. Results differed greatly, as did depth and representation types.

Seating groups, sofas, and bistro tables served as stations. The local changes facilitated new perspectives.

Later, results were exchanged and new fields of action defined. The lack of presentation possibilities (no flipcharts) and noise made this part less productive, so we recommend \"Ackerspace\" at a quieter location with metaplan wall for such work.

Sometimes you were observed, sometimes the observer – groups of visitors rarely disrupted, staying at a safe distance.

After a tiring middle part came a break. Table football and round changes helped clear our minds.

Energized, we started prioritizing open fields of action. The goal: finish tasks needing everyone. We defined next steps together, splitting into three groups to tackle the biggest remaining problem from different perspectives.

What you see here are not thought bubbles, but a svg of the exhibition space. Could've been thought bubbles though.

After discussion-packed rounds, we defined next steps and responsibilities, gave feedback, and tidied up (perhaps quickly because sushi and steaks awaited nearby).

Unlike [the movie](https://www.rottentomatoes.com/m/night_at_the_museum/), our night at the museum was not horrible, but a very positive experience. Special thanks to ZKM and Mrs. Kiolbassa, who helped greatly in advance and on site!


